import { useEffect, useState } from 'react';
import styles from './Wordmark.module.css';

// El hilo se cose una vez por visita: al navegar entre secciones la marca se vuelve a montar sin repetirlo.
let sewn = false;

/** Marca: la palabra «hilo» sobre el hilo añil que la sostiene. */
export function Wordmark({ size = 'md', tone = 'default' }: { size?: 'md' | 'lg'; tone?: 'default' | 'inverse' }) {
  const [sew] = useState(() => !sewn);
  useEffect(() => {
    sewn = true;
  }, []);
  return (
    <span className={`${styles.mark} ${size === 'lg' ? styles.lg : ''} ${tone === 'inverse' ? styles.inverse : ''}`} data-sew={sew || undefined}>
      <svg className={styles.thread} viewBox="0 0 120 20" preserveAspectRatio="none" aria-hidden="true" focusable="false">
        <path d="M2 10 C 20 18, 34 2, 58 9 S 96 18, 118 4" pathLength={1} />
      </svg>
      <span className={styles.word}>hilo</span>
    </span>
  );
}
